import { Pipe, PipeTransform } from '@angular/core';
import { DateTime, ToRelativeUnit } from 'luxon';

@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date, unit: ToRelativeUnit = null): string {
    const lDate = DateTime.fromJSDate(value);
    return lDate.toRelative({ unit });
  }
}
